import request from '@/utils/request'

export interface IUserCouponAdmin {
  id: number
  userId: number
  userName?: string
  userPhone?: string
  couponId: number
  couponName?: string
  amount?: number
  minAmount?: number
  status: number
  getTime?: string
  useTime?: string
  expireTime?: string
}

export function getUserCouponPage(params: {
  pageNum: number
  pageSize: number
  userId?: number
  couponId?: number
  status?: number
}) {
  return request({
    url: '/userCoupon/page',
    method: 'get',
    params
  })
}

export function invalidateUserCoupon(id: number) {
  return request({
    url: `/userCoupon/${id}/invalidate`,
    method: 'post'
  })
}

export function restoreUserCoupon(id: number, expireTime: string) {
  return request({
    url: `/userCoupon/${id}/restore`,
    method: 'post',
    params: { expireTime }
  })
}
